import React from "react";
import './index.css'
import { color } from "../../utils/themes/color";

export default function TEXTROW(props) {

    return (
        <textarea
            className="m-textarea"
            type={props.type != undefined ? props.type : "text"}
            value={props.value != undefined && props.value != null ? props.value : ""}
            maxLength={props.maxLength != undefined ? props.maxLength : ""}
            rows={props.rows != undefined && props.rows != null ? props.rows : ""}
            style={{ color: color.primary }}
            onChange={(e) => props.i(e.target.value)} />
    )


}